import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import {
  GetCompanyDto,
  GetPurchaserDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface SalesInvoiceMissingSymphonyCodeAlertProps {
  purchaser?: GetPurchaserDto;
  recipientClientId?: string;
  company?: GetCompanyDto;
}

export const SalesInvoiceMissingSymphonyCodeAlert: React.FC<
  SalesInvoiceMissingSymphonyCodeAlertProps
> = props => {
  const [isPurchaserSymphonyCodeMissing, setIsPurchaserSymphonyCodeMissing] =
    useState(false);
  const [isRecipientSymphonyCodeMissing, setIsRecipientSymphonyCodeMissing] =
    useState(false);
  const pok = usePokCore();
  const notifications = useNotifications();
  const companyId = pok.getCompanyId();
  const { t, tk } = useTranslation('fvsLng');

  useEffect(() => {
    if (props.purchaser?.client?.id) {
      pok.symphonyClients
        .getByClientCompany(props.purchaser.client.id, companyId)
        .then(data => {
          setIsPurchaserSymphonyCodeMissing(!data.length);
        })
        .catch(errorResponse => {
          notifications.caughtError(errorResponse);
        });
    } else {
      setIsPurchaserSymphonyCodeMissing(false);
    }

    if (props.recipientClientId) {
      pok.symphonyClients
        .getByClientCompany(props.recipientClientId, companyId)
        .then(data => {
          setIsRecipientSymphonyCodeMissing(!data.length);
        })
        .catch(errorResponse => {
          notifications.caughtError(errorResponse);
        });
    } else {
      setIsRecipientSymphonyCodeMissing(false);
    }
  }, [
    companyId,
    notifications,
    pok.symphonyClients,
    props.purchaser?.client.id,
    props.recipientClientId,
  ]);

  if (
    props.company?.symphonyHandel &&
    (isPurchaserSymphonyCodeMissing || isRecipientSymphonyCodeMissing)
  ) {
    return (
      <Alert variant="warning">
        {isPurchaserSymphonyCodeMissing && (
          <p className="m-0">
            {t(tk.symphony.symphonyNumberNotFound)}{' '}
            <b>{props?.company?.name}</b>.{' '}
            {t(tk.symphony.invoiceWontBeImported)}
          </p>
        )}
        {isRecipientSymphonyCodeMissing && (
          <p className={isPurchaserSymphonyCodeMissing ? 'mt-1 mb-0' : 'm-0'}>
            {t(tk.finance.noSymphonyCodeForRecipient)}{' '}
            <b>{props?.company?.name}</b>.{' '}
            {t(tk.symphony.invoiceWontBeImported)}
          </p>
        )}
      </Alert>
    );
  }

  return null;
};
